import { FC } from 'react';

import { useTranslations } from '../hooks/useTranslations';
import { translationKeys } from '../translations/translationKeys';
import ThankYouContent from './ThankYouContent';
import ThankYouScreenWrapper, { ThankYouScreenProps } from './ThankYouScreenWrapper';

const ThankYouScreenContainerSpectre: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();
  return (
    <ThankYouScreenWrapper {...props} title={translate(translationKeys.THANK_YOU_SPECTRE_TITLE)}>
      <ThankYouContent embedded={props.embedded} />
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenContainerSpectre;
